import React, {useContext} from 'react';
import NewTabulator from "../../NewTabulator/NewTabulator";
import {SellFactorSCLContext} from "../SellFactorContext";
import tableCalc from "../../../utils/tableCalc";
import {calculateNewDataInFactor} from "../../BuyFactorSadan/FactorFunctions";
import {handleChangeKeyValue, handleDeleteRow, sumEachRow} from "./functions";
import {deleteRowInSubmitForm} from "../../AccountingCoding/SubmitDocumentForm/functions";
import SelectMoienFormatter
  from "../../AccountingCoding/SubmitDocumentForm/TableColumnsFormatters/SelectMoienFormatter";
import {v4 as uuidV4} from "uuid";
import utilsFunction from "../../../utils/utilsFunction";

function SclJozTable(props) {

  const helper = useContext(SellFactorSCLContext);
  const setData = helper.setData
  const data = helper.data


  const myColumnsSclJozTable = [
    {
    title: "ردیف",
    field: "rowId",
    // formatter: tableCalc.persianDigits,
    style: {display: "flex", minWidth: 30, maxWidth: 30, width: 30 , textAlign:"center"}
  },
    {title: "کد", field: "productId", formatter: tableCalc.persianDigits,
      style: {display: "flex", minWidth: 35, justifyContent:"center",},

    },
    {title: "عنوان محصول", field: "productName",

    style: {display: "flex", minWidth: 250, justifyContent:"center"}},
    {title: "کد قیمت", field: "priceId", formatter: tableCalc.persianDigits,  },
    {title: "قیمت", field: "price",
      formatter: tableCalc.persianDigits,
    },
    {title: "واحد", field: "unit"},
    {title: "وزن",
      style: {display: "flex", justifyContent:"center", alignItem:"center"},
      field: "weight",
      editor: "number",
      formatter: tableCalc.persianDigits,
      bottomCalc: tableCalc.sum,

    cellEdited: function (e, cell) {

      const uniqId = cell.getData().uniqId;
      let newWeight = (e.target.value)
      newWeight = utilsFunction.LimitDotAndThreeCharsAfterDot(newWeight)
      const newProductsData = handleChangeKeyValue(data.sendData.productsData, uniqId, "weight", newWeight)
      const newTableData = sumEachRow(newProductsData)
      setData({sendData: {...data.sendData, productsData: newTableData}})
    },


  }, {title: "تخفیف", field: "discount",
      visible:false,
      formatter: tableCalc.persianDigits,
      style: {display: "flex", justifyContent:"center", alignItem:"center"},
    },
    {
    title: "وضعیت", field: "factorStatus",
      style: {display: "flex", justifyContent:"center", alignItem:"center"},

    formatter: (cell) => {

      const uniqId = cell.getData().uniqId;
      const handleChange = (e) => {
        const value = e.target.value;

        const newProductData = handleChangeKeyValue(data.sendData.productsData, uniqId, "factorStatus", value)
        setData({sendData: {...data.sendData, productsData: newProductData}})

      }

      const currentValue = data.sendData.productsData.find(v => v.uniqId === uniqId)?.factorStatus

      try {
        return <div key={uuidV4()}>
          <select
            className={"rtl"}
            onChange={handleChange}
            value={currentValue}
          >
            <option value="inProcess">در حال انجام</option>
            <option value="accepted">قبول شده</option>
            <option value="sending">در حال ارسال</option>
            <option value="delivered">تحویل شده</option>
          </select>
        </div>
      } catch (error) {
        return <>{error.toString()}</>
      }
    },
  },
    {
    title: "جمع", field: "sum", bottomCalc: tableCalc.sum,
      formatter: tableCalc.persianDigits,
      style: {display: "flex", justifyContent:"center", alignItem:"center"},

  },
    {
      title: "حذف", formatter: "buttonCross",
      style: {display: "flex", justifyContent:"center", alignItem:"center"},
      cellClick: function (e, cell) {

        const uniqId = cell.getData().uniqId;
        const newProductsData = handleDeleteRow(data.sendData.productsData, uniqId)
        const newProductsData1 =  utilsFunction.addRowIdToTable(newProductsData)
        setData({sendData: {...data.sendData, productsData: newProductsData1}})

      }
    },
  ]


  return (<div
    className={"m-2"}
  >

    <NewTabulator
      columns={myColumnsSclJozTable}
      data={data.sendData.productsData}
      className={"header__color__F1F1F1"}
      style={{height: "60vh", overflow: 'scroll'}}
    />
  </div>);
}

export default SclJozTable;